import { theme } from '@/styles/theme';

export const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundSize: 'cover',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      height: '100%',
    },
  },
  background: {
    position: 'fixed',
    width: '100%',
    height: '100%',
    backgroundColor: '#000000',
    opacity: 0.24,
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'center',
    width: '100%',
    paddingLeft: 6,
    paddingRight: 6,
    paddingTop: 4,
    paddingBottom: 2,
    maxWidth: '648px',
    boxSizing: 'border-box',
    borderRadius: '8px',
    backgroundColor: '#FFFFFF',
    zIndex: 9999,
    marginLeft: 2,
    marginRight: 2,
  },
  title: {
    textAlign: 'start',
    fontWeight: 500,
    fontSize: '18px',
    color: theme.palette.popup.light,
  },
  description: {
    fontSize: '16px',
    textAlign: 'start',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.gray.main,
  },
  buttonContent: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginTop: 2,
    marginBottom: 2,
    gap: 1,
  },
  textsBox: {
    direction: 'flex',
    paddingTop: 2,
    paddingBottom: 2,
    width: '100%',
  },
  dateCodeBox: {
    direction: 'flex',
    flexDirection: 'row',
    width: '100%',
    gap: 2,
  },
  dateCsc: {
    width: '100%',
    marginRight: 0,
  },
  day: {
    '&.MuiPickersDay-root.Mui-selected': {
      backgroundColor: theme.palette.focus.main,
    },
    '&.MuiPickersDay-today': {
      backgroundColor: 'transparent',
      border: 'none',
    },
  },
};
